import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box } from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import TimesheetList from './TimesheetList';

export default function TrackedTimeDialog({ issueId, onClose }: { issueId: number, onClose: () => void }) {
    return (
        <Box>
            <Dialog
                open={true}
                onClose={onClose}
                fullWidth={true}
                maxWidth="xl"
                scroll='paper'
            >
                <DialogTitle>Время работ по задаче</DialogTitle>
                <HighlightOffOutlinedIcon sx={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer' }} onClick={onClose} />
                <DialogContent sx={{ height: '85vh', overflow: 'hidden', position:'relative' }}>
                    <TimesheetList issueId={issueId} />
                </DialogContent>
            </Dialog>
        </Box>
    );
}